const skills = [
  {
    name: "C++",
    src: "assets/cplusplus.svg",
  },
  {
    name: "CSS 3",
    src: "assets/css3.svg",
  },
  {
    name: "ExpressJS",
    src: "assets/express.svg",
  },
  {
    name: "Figma",
    src: "assets/figma.svg",
  },
  {
    name: "Github",
    src: "assets/github.svg",
  },
  {
    name: "GSAP",
    src: "assets/greensock.svg",
  },
  {
    name: "JavaScript",
    src: "assets/javascript.svg",
  },
  {
    name: "JSON",
    src: "assets/json.svg",
  },
  {
    name: "JWT",
    src: "assets/jsonwebtokens.svg",
  },
  {
    name: "mongoDB",
    src: "assets/mongodb.svg",
  },
  {
    name: "netlify",
    src: "assets/netlify.svg",
  },
  {
    name: "NextJS",
    src: "assets/nextdotjs.svg",
  },
  {
    name: "NodeJS",
    src: "assets/nodedotjs.svg",
  },
  {
    name: "PostgreSQL",
    src: "assets/postgresql.svg",
  },
  {
    name: "ReactJS",
    src: "assets/react.svg",
  },
  {
    name: "React Router",
    src: "assets/reactrouter.svg",
  },
  {
    name: "Redux",
    src: "assets/redux.svg",
  },
  {
    name: "SASS",
    src: "assets/sass.svg",
  },
  {
    name: "VirtualBox",
    src: "assets/virtualbox.svg",
  },
  {
    name: "Firebase",
    src: "assets/firebase.svg",
  },
  {
    name: "HTML",
    src: "assets/html5.svg",
  },
];

export default skills;
